import {
  GENERATE_ONBOARD_LINK,
  GENERATE_ONBOARD_LINK_FAILED,
  GENERATE_ONBOARD_LINK_SUCCESS,
  SAVE_NPS_BASIC_DETAILS,
  SAVE_NPS_BANK_DETAILS,
  SAVE_NPS_REJECTION_DETAILS,
  SAVE_NPS_STATUS,
  SAVE_NPS_ACTIVE_BODY,
  SAVE_AGENT_REFNO,
} from "../types";

import { CALL_API } from "../api.middleware";

export function generateOnboardUrl(body) {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNps: true,
          url: "/NPSMFDSubsRegistration",
          body: body,
          types: [
            GENERATE_ONBOARD_LINK,
            GENERATE_ONBOARD_LINK_SUCCESS,
            GENERATE_ONBOARD_LINK_FAILED,
          ],
        },
      });
    } catch (e) {
      alert(e);
    }
  };
}
export function agentEmpanelementRegistration(body) {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsFile: true,
          url: "/AgentRegistrationV2",
          body: body,
        },
      });
    } catch (e) {
      alert(e);
    }
  };
}
export function getRejectionDetails(body) {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNps: true,
          url: "/NPSMFDAgentEmpanelmentDetails",
          body,
        },
      });
    } catch (e) {
      alert(e);
    }
  };
}
export function getMisPending(body) {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNps: true,
          url: "/NPSMFDAgentPendingSubscribers",
          body,
        },
      });
    } catch (e) {
      alert(e);
    }
  };
}
export function getMisCompleted(body) {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNps: true,
          url: "/NPSMFDAgentCompletedSubscribers",
          body,
        },
      });
    } catch (e) {
      alert(e);
    }
  };
}
export function getMisContributed(body) {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNps: true,
          url: "/NPSMFDAgentContributedSubscribers",
          body,
        },
      });
    } catch (e) {
      alert(e);
    }
  };
}
export function checkEmpanelementStatus(body) {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNps: true,
          url: "/GetEmpanelmentStatus",
          body,
        },
      });
    } catch (e) {
      alert(e);
    }
  };
}
export const saveNpsBasicDetails = (data) => {
  return {
    type: SAVE_NPS_BASIC_DETAILS,
    body: data,
  };
};
export const saveNpsBankDetails = (data) => {
  return {
    type: SAVE_NPS_BANK_DETAILS,
    body: data,
  };
};
export const saveRejectionDetails = (data) => {
  return {
    type: SAVE_NPS_REJECTION_DETAILS,
    body: data,
  };
};
export const saveNpsStatusCodes = (body) => {
  return {
    type: SAVE_NPS_STATUS,
    body,
  };
};

export const enableAdditionalPurchase = () => {
  return {
    type: "NPS_ENABLE_ADDITIONAL_PURCHASE",
  };
};

export const saveAgentReferenceNumber = (body) => {
  return {
    type: SAVE_AGENT_REFNO,
    body,
  };
};
export const saveActiveBody = (body) => {
  return {
    type: SAVE_NPS_ACTIVE_BODY,
    body,
  };
};
